// removed by extract-text-webpack-plugin
module.exports = {"labelBox":"_1PzONVoptgiXoXe-fziour","label":"Gi0LrVlFlbliHlArWLGP8","colonLabel":"_2lzZnOkNQBY17AM0L53M3m","icon":"_30YoK6-acyReOhxODhJVJx","tips":"_1rfTmKeRZvCU6dMg-s0nZa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TipLabel/index.m.less
// module id = 762
// module chunks = 0